import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import ptBR from 'date-fns/locale/pt-BR';

export default function DateTimePickerControl(props) {

    const { label, format, value, handleChange, error=null, required } = props;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <MobileDateTimePicker
                label={label}
                inputFormat={format}
                value={value}
                onChange={handleChange}
                renderInput={(params) => <TextField {...params}
                    {...(error && { error: true, helperText: error })}
                    required={required} />}
            />
        </LocalizationProvider>
    )
}
